module.exports = __webpack_public_path__ + "img/common-popup-hen.12f9d5af.png";